import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";
import EGWB from "../../assets/images/EGWB-logo.svg";

export default function AuthHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);

  // Check if there is a pending or inactive plan
  const hasPendingPlan = auth.plans.some(
    (plan) => plan.status === "pending" || plan.status === "inactive"
  );

  // Handler for back button navigation
  const handleBackNavigation = () => {
    if (hasPendingPlan) {
      // Redirect to choose-plan if there is a pending or inactive plan
      navigate("/");
    } else {
      // Otherwise, go back to the previous page
      navigate(-1);
    }
  };

  return (
    <div className="auth-header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex align-items-center gap-3 position-relative">
            {location.pathname === "/signup" ||
            location.pathname === "/organization" ||
            location.pathname === "/user-type" ||
            location.pathname === "/forgot-confirmation-code" ||
            location.pathname === "/choose-plan" ||
            location.pathname === "/checkout" ||
            location.pathname === "/confirmation-code" ? (
              <button
                className="bg-transparent border-0 p-0 back-button"
                onClick={handleBackNavigation} // Use the handler instead of navigate(-1)
              >
                <svg
                  width="21"
                  height="18"
                  viewBox="0 0 34 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.75 13L32 13M1.75 13L12.25 2.5M1.75 13L12.25 23.5"
                    stroke="black"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            ) : (
              ""
            )}

            <Link to={"/"} className="logo d-flex align-items-center gap-3">
              <LazyLoadImage src={EGWB} alt={""} effect="blur" />
              <strong className="fw-semibold pNovaFamily">
                <span>EGWB</span>
              </strong>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}